import React, { useEffect } from 'react';
import { LegalPage } from './LegalPage';
const sections = [{
  title: 'Introduction',
  content: '888 Sourcing Limited ("we", "us", "our") is committed to protecting your privacy and complying with UK and EU data protection laws, including the UK GDPR and the Data Protection Act 2018. This Privacy Policy explains how we collect, use, and protect personal data when you interact with our website and services.'
}, {
  title: 'Information We Collect',
  content: ['We may collect the following personal information when you use our website or contact us:', '• Name, job title, and company details', '• Email address, phone number, and postal address', '• Website usage data (e.g., pages visited, time spent, IP address)', '• Any information you provide in inquiries or correspondence']
}, {
  title: 'How We Use Your Data',
  content: ['Your personal data is used for purposes including:', '• Responding to inquiries and providing our services', '• Managing business relationships with manufacturers, retailers, and distributors', '• Sending relevant communications or updates (you may opt-out at any time)', '• Improving our website and services']
}, {
  title: 'Data Sharing and Transfers',
  content: 'We do not sell or rent your personal information. We may share data with trusted third-party service providers who support our business operations, such as IT, payment processing, or logistics partners. Any international transfers comply with applicable UK and EU data protection laws.'
}, {
  title: 'Data Security',
  content: 'We implement appropriate technical and organizational measures to protect personal data against unauthorized access, loss, or misuse.'
}, {
  title: 'Your Rights',
  content: ['You have the right to:', '• Access and receive a copy of your personal data', '• Correct any inaccuracies in your data', '• Request erasure of your data', '• Restrict or object to processing', '• Withdraw consent at any time where processing is based on consent']
}, {
  title: 'Cookies and Tracking',
  content: 'Our website may use cookies to enhance user experience, analyze traffic, and provide personalized content. You can manage or disable cookies via your browser settings.'
}, {
  title: 'Retention of Data',
  content: 'We retain personal data only as long as necessary to fulfill the purposes outlined in this policy or as required by law.'
}, {
  title: 'Changes to this Policy',
  content: 'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.'
}];
export function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = 'Privacy Policy | 888 Sourcing Limited';
    window.scrollTo(0, 0);
  }, []);
  return <LegalPage title="Privacy Policy" lastUpdated="January 2024" sections={sections} showContactInfo={true} data-id="element-645" />;
}